import { Component, inject, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, firstValueFrom, Subscription } from 'rxjs';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';
import { PhysicalInventoryService } from 'src/app/services/inventory/physical-inventory.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';

@Component({
  selector: 'app-adjust-excess-modal',
  templateUrl: './adjust-excess-modal.component.html',
  styleUrls: ['./adjust-excess-modal.component.scss'],
  standalone: false
})
export class AdjustExcessModalComponent implements OnInit {

  private readonly config = inject(DynamicDialogConfig);
  private readonly ref = inject(DynamicDialogRef);
  private readonly physicalInventoryService = inject(PhysicalInventoryService);
  private readonly toastHandlerService = inject(ToastHandlerService);

  branchId: number = 0;
  input$: BehaviorSubject<any>;
  listStore: any[] = [];
  inventoryId: number = 0;
  selectedStoreId: number = 0;
  storeId: number = 0;
  suscription: Subscription;

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.suscription = input$?.subscribe((inputs: any) => {
      this.branchId = inputs.branchId;
      this.inventoryId = inputs.inventoryId;
      this.storeId = inputs.storeId;
      this.selectedStoreId = inputs.storeId;
    });
    await this.getListStore();
  }

  ngOnDestroy() {
    this.suscription?.unsubscribe();
  }

  async getListStore() {
    try {
      this.listStore = await firstValueFrom(this.physicalInventoryService.getAllStoresForSelectAsync(this.branchId, this.inventoryId));
      return true;
    } catch (error) {
      console.error('Error al obtener la lista de bodegas.', error);
      return false;
    }
  }

  async send() {
    if (this.selectedStoreId <= 0) {
      this.toastHandlerService.showToast('warning', 'El campo Bodega es obligatorio.', 'Atención');
      return;
    }
    const data: ModalObjectType = {};
    data.params = { selectedStoreId: this.selectedStoreId };
    this.ref.close(data);
  }

}
